/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SendCreatorSubscriptionEmailRequest,
    SendCreatorSubscriptionEmailRequest2,
} from '../models';

export interface SubscriptionEmailApiControllerSendCreatorSubscriptionEmailV2Request {
    sendCreatorSubscriptionEmailRequest2: SendCreatorSubscriptionEmailRequest2;
}

export interface SubscriptionEmailApiControllerSendCreatorSubscriptionEmailsRequest {
    sendCreatorSubscriptionEmailRequest: SendCreatorSubscriptionEmailRequest;
}

/**
 * 
 */
export class SubscriptionEmailApi extends runtime.BaseAPI {

    /**
     */
    async subscriptionEmailApiControllerSendCreatorSubscriptionEmailV2Raw(requestParameters: SubscriptionEmailApiControllerSendCreatorSubscriptionEmailV2Request): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sendCreatorSubscriptionEmailRequest2 === null || requestParameters.sendCreatorSubscriptionEmailRequest2 === undefined) {
            throw new runtime.RequiredError('sendCreatorSubscriptionEmailRequest2','Required parameter requestParameters.sendCreatorSubscriptionEmailRequest2 was null or undefined when calling subscriptionEmailApiControllerSendCreatorSubscriptionEmailV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v2/creator-subscription-email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendCreatorSubscriptionEmailRequest2,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionEmailApiControllerSendCreatorSubscriptionEmailV2(requestParameters: SubscriptionEmailApiControllerSendCreatorSubscriptionEmailV2Request): Promise<void> {
        await this.subscriptionEmailApiControllerSendCreatorSubscriptionEmailV2Raw(requestParameters);
    }

    /**
     */
    async subscriptionEmailApiControllerSendCreatorSubscriptionEmailsRaw(requestParameters: SubscriptionEmailApiControllerSendCreatorSubscriptionEmailsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sendCreatorSubscriptionEmailRequest === null || requestParameters.sendCreatorSubscriptionEmailRequest === undefined) {
            throw new runtime.RequiredError('sendCreatorSubscriptionEmailRequest','Required parameter requestParameters.sendCreatorSubscriptionEmailRequest was null or undefined when calling subscriptionEmailApiControllerSendCreatorSubscriptionEmails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/creator-subscription-email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendCreatorSubscriptionEmailRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionEmailApiControllerSendCreatorSubscriptionEmails(requestParameters: SubscriptionEmailApiControllerSendCreatorSubscriptionEmailsRequest): Promise<void> {
        await this.subscriptionEmailApiControllerSendCreatorSubscriptionEmailsRaw(requestParameters);
    }

}
